import { render } from "./internetcable-provider.vue?vue&type=template&id=5644c562"
import script from "./internetcable-provider.js?vue&type=script&lang=js"
export * from "./internetcable-provider.js?vue&type=script&lang=js"

import "./internetcable-provider.vue?vue&type=style&index=0&id=5644c562&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__